import axios from 'axios'

export default {
    getAll: () => axios.get('/news_telegram'),
    getById: id => axios.get(`/news_telegram/${id}`),
    create: formData => axios.post(`/news_telegram/create`, formData),
    edit: formData => axios.put(`/news_telegram/edit`, formData),
    delete: id => axios.delete(`/news_telegram/delete/${id}`)
}